module.exports = __webpack_public_path__ + "img/SES_1013178.fe592d9a.jpg";